<template>
  <div>
    <div class="flex">
      Votre parapheur a été conçu pour vous permettre de gérer avec une grande liberté vos dossiers (document à signer,
      éléments à viser, éléments de langage, comptes rendus, commandes, archivage…).
    </div>
    <div>
      <PAccordion
        label="Éléments non pris en charge"
        label-tag="h2"
        class="mt-2 [&>button]:border-grey-625 border-b-grey-625"
      >
        <div class="flex flex-col pl-4">
          <div v-for="(label, index) of forbiddenDocTypes" :key="index">
            <OhVueIcon :name="wrongWayIcon" class="mr-1 text-red-marianne-425" />
            {{ label }}
          </div>
        </div>
      </PAccordion>
      <PAccordion label="Affichage" label-tag="h2" class="mt-2 [&>button]:border-grey-625 border-b-grey-625">
        <p class="mb-1">
          Pour bénéficier d'un affichage optimal, il est recommandé de mettre le zoom à 80% sur le navigateur internet.
        </p>
      </PAccordion>
      <PAccordion
        label="Règlement Général sur la Protection des Données (RGPD)"
        label-tag="h2"
        class="mt-2 [&>button]:border-grey-625 border-b-grey-625"
      >
        <p>
          Nous vous rappelons qu’au regard de la réglementation sur la protection sur les données à caractère personnel,
          les informations collectées sur les personnes doivent être adéquates, pertinentes et non excessives au regard
          de la finalité du traitement envisagé, qu'il soit automatisé ou au format papier. Nous vous invitons à ne
          télécharger que les documents strictement nécessaires à la gestion du parapheur. Une attention particulière
          doit être portée aux données sensibles visées par l'article 9 du RGPD (origine raciale ou ethnique, opinions
          politiques, religieuses ou philosophiques, appartenance syndicale, données de santé, orientation sexuelle,
          données génétiques ou biométriques).
          <br />
          Ces informations ne doivent pas figurer dans le contenu des courriers ou pièces-jointes traités.
        </p>
        <div class="mt-1 mb-1">
          <h3 class="font-bold mb-1">Cas spécifique des courriers externes</h3>
          <p class="mb-1">
            Le ministère en tant que responsable du système d'information doit informer les personnes extérieures
            (usagers ou contacts professionnels) qui sont également des personnes concernées par le traitement de leurs
            données et sur leurs droits.
          </p>
          <p>
            Aussi, nous vous invitons à adopter une information en plusieurs niveaux, en intégrant une mention
            d'information synthétique dans les courriers de réponses ou accusé de réception qui renvoie vers une
            politique de confidentialité en ligne.
          </p>
        </div>
      </PAccordion>
    </div>
    <div class="mt-2" v-if="config.cguLink">
      <span class="text-grey-425">Consulter&nbsp;</span>
      <PLink :to="config.cguLink"> les conditions générales d'utilisation.</PLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PAccordion, PLink, useConfig, useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { RiIndeterminateCircleFill } from "oh-vue-icons/icons";
import { type ParapheurConfig } from "../../types";

const config = useConfig<ParapheurConfig>();

const [wrongWayIcon] = useIcons(RiIndeterminateCircleFill);

const forbiddenDocTypes = [
  "Document classifié",
  "Document portant la mention « personnel »",
  "Bulletin de paie",
  "Facture",
  "Dépôt de proposition en réponse à des consultations",
  "Courrier généré / transitant via portail métier",
  "Demande métiers (ex: demande de CEE)",
  "Autres documents issus de logiciel métier tiers",
];
</script>
